import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';

@Component({
    selector: 'app-bx-datatable-select-all-header',
    template: `
        <div class="checkbox clip-check check-primary margin-top-0 margin-bottom-0 margin-left-5">
            <input legacy-css type="checkbox" id="{{ checkBoxId }}SelectAll" [checked]="allRowsSelected" (change)="toggleSelectAll()" />
            <label for="{{ checkBoxId }}SelectAll">
                <span class="datatable-header-cell-label">{{ label }} </span>
            </label>
        </div>
    `,
    standalone: false,
})
export class BxDatatableSelectAllHeaderComponent {
    @Input() checkBoxId: string = '';
    @Input() label: string = '';
    @Input() allRowsSelected: boolean = false;
    @Output() toggleAllRowsSelected = new EventEmitter<boolean>();

    toggleSelectAll() {
        this.allRowsSelected = !this.allRowsSelected;
        this.toggleAllRowsSelected.emit(this.allRowsSelected);
    }
}

@NgModule({
    declarations: [BxDatatableSelectAllHeaderComponent],
    exports: [BxDatatableSelectAllHeaderComponent],
})
export class DatatableSelectAllHeaderComponentModule {}
